<template>
  <tab-layout>
    <payment :cartMembers="cartMembers" :type="'committee-affiliation'" slot="tabContent" class="tab-pane col-12 col-xl-9 px-0 show active" id="payment" role="tabpanel" aria-label="Payment" />
  </tab-layout>
</template>

<script>

import tabLayout from '@/components/TabLayout'
import Payment from '@/components/Payment'

export default {
  name: "CommitteePayment",
  components: {
    'tab-layout': tabLayout,
    payment: Payment
  },
  data() {
    return {
      cartMembers: this.$store.state.cartMembers
    }
  },
  mounted() {
    if (!('total' in this.cartMembers)) {
      this.$router.push('/committees/cart')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Committees/Cart/Payment.vue